import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { itemprop: "name" }
const _hoisted_2 = ["content"]
const _hoisted_3 = { key: 0 }

import Typography from '@/components_new/Typography.vue'
import Link from '@/components_new/Link.vue'
import { RouteLocationRaw } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Typography, {
    is: "ul",
    type: "paragraph",
    size: "xs",
    itemscope: "",
    itemtype: "https://schema.org/BreadcrumbList",
    class: _normalizeClass(_ctx.$style.breadcrumbs)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.title,
          itemprop: "itemListElement",
          itemscope: "",
          itemtype: "https://schema.org/ListItem"
        }, [
          _createVNode(Link, {
            itemprop: "item",
            to: item.href,
            disabled: item.disabled,
            color: "white-40"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1),
              _createElementVNode("meta", {
                itemprop: "position",
                content: `${index + 1}`
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["to", "disabled"]),
          (index !== _ctx.items.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/"))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})